module.exports = __webpack_public_path__ + "img/sche_pic3.6496be58.jpg";